module.exports = __webpack_public_path__ + "static/media/cmct-men-aaa.b71dd3f5.jpg";